import { useQuery } from '@tanstack/react-query';
import type { Product } from '../data/product';
import { productCostHistoryQueryOptions } from '../query/query-options';
import { storeLayout } from '../router';

export function useProductCostHistory(product: Product, options: { enabled: boolean }) {
  const { store, storeService } = storeLayout.useRouteContext();

  const { data, isLoading } = useQuery({
    ...productCostHistoryQueryOptions(store.id, product.vendor_id, product.id),
    queryFn: () => storeService.getProductCostHistory(store.id, product.vendor_id, product.id),
    enabled: options.enabled,
  });

  return { costHistory: data, loading: isLoading };
}
